import React, { useMemo } from 'react';

import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import useStyles from './useStyles';
import { Carousel } from '../Carousel';
import { ImageItem } from './CarouselImageItem';

export const CarouselSlider = React.memo(({
  images,
  classNames = {},
  carouselConfig = {},
}) => {
  const classes = useStyles();

  const getImageProps = (imageItem) => {
    if (typeof imageItem === 'string') {
      return {
        src: imageItem,
        onClick: null,
        alt: '',
      };
    }

    const { image, onClick = '', alt = '' } = imageItem;
    return {
      src: image,
      onClick: onClick || null,
      alt,
    };
  };

  const carouselItems = useMemo(() => {
    if (!images?.length) return [];

    return images.map((image) => {
      const { src, onClick, alt } = getImageProps(image);
      return (
        <Box
          key={src}
          className={clsx(classes.imgContainer, {
            [classNames?.imgContainer]: classNames?.imgContainer,
          })}
        >
          <ImageItem
            src={src}
            onClick={onClick}
            alt={alt}
            classes={classes}
            classNames={classNames}
          />
        </Box>
      );
    });
  }, [images, classes, classNames]);

  if (!carouselItems.length) {
    return null;
  }

  return (
    <Carousel
      items={carouselItems}
      autoplay={carouselConfig?.autoplay}
      staticMode={carouselConfig?.staticMode}
    />
  );
});

CarouselSlider.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        image: PropTypes.string.isRequired,
        onClick: PropTypes.string,
        alt: PropTypes.string,
      }),
    ]),
  ),
  classNames: PropTypes.shape({
    img: PropTypes.string,
    imgContainer: PropTypes.string,
  }),
  carouselConfig: PropTypes.shape({
    autoplay: PropTypes.bool,
    staticMode: PropTypes.bool,
  }),
};

CarouselSlider.defaultProps = {
  images: [],
  classNames: {},
  carouselConfig: {
    autoplay: true,
    staticMode: false,
  },
};
